import script from "./FamilyGroupMemberHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupMemberHistory.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupMemberHistory.vue?vue&type=style&index=0&id=3115f808&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3115f808"]])

export default __exports__